export default __webpack_public_path__ + "static/media/logout.4c225799.gif";